// extracted by mini-css-extract-plugin
export default {"row":"WMF71rJWk0Pq4_lvkdxB"};